export default __webpack_public_path__ + "static/media/disable_pencil.8b66f0a8.svg";